import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { NgIf } from "@angular/common";
import { TranslateModule } from '@ngx-translate/core'

export type AlertType = 'success' | 'info' | 'warning' | 'error' | 'default';

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    standalone: true,
    imports: [NgIf, TranslateModule],
    styleUrl: './alert.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
    @Input() type: AlertType = 'default';
    @Input() icon = true;
    @Input() closable = false;
    @Input() fullHeight = false
    @Output() closed = new EventEmitter<void>();
    
    visible = true;

    getBackgroundColor(): string {
        const backgroundColors = {
            info: 'bg-semantic-background-info',
            warning: 'bg-semantic-background-warning',
            error: 'bg-semantic-background-error',
            success: 'bg-semantic-background-success',
            default: ''
        };

        return backgroundColors[this.type] || '';
    }
    
    closeAlert(): void {
        this.visible = false;
        this.closed.emit();
    }
}
